// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3JJGE","content":"styles_content__r5cUT","checkbox":"styles_checkbox__q1ZBr","checkboxLabel":"styles_checkboxLabel__TlMXE"};